(function () {
    'use strict';

    function initTeamFilter(form) {
        var select = form.querySelector('.js-team-filter');
        if (!select) return;

        var section = form.closest('section') || document;
        var cards = section.querySelectorAll('.js-team-card');
        if (cards.length === 0) return;

        function applyFilter() {
            var selected = (select.value || '').trim();

            for (var i = 0; i < cards.length; i++) {
                var card = cards[i];

                if (!selected) {
                    card.style.display = '';
                    continue;
                }

                var sectors = (card.getAttribute('data-sectors') || '').split(/\s+/);
                card.style.display = sectors.indexOf(selected) !== -1 ? '' : 'none';
            }
        }

        select.addEventListener('change', applyFilter);
        form.addEventListener('submit', function (e) {
            e.preventDefault();
            applyFilter();
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        var forms = document.querySelectorAll('.js-team-filter-form');
        for (var i = 0; i < forms.length; i++) {
            initTeamFilter(forms[i]);
        }
    });
})();
